import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Color } from 'app/shared/models/class/color/color';
import { Tag } from 'app/shared/models/class/tags/tag';
import { ColorService } from 'app/shared/services/color/color.service';
import { TagService } from 'app/shared/services/tag/tag.service';

@Component({
  selector: 'app-change-color-tag',
  templateUrl: './change-color-tag.component.html',
  styleUrls: ['./change-color-tag.component.scss']
})
export class ChangeColorTagComponent implements OnInit {
  @Input() tag: Tag;
  @Output() updateTag = new EventEmitter();

  colors: Color[];
  selected: Color;

  constructor(
    private colorService: ColorService,
    private tagsService: TagService,
  ) { }

  ngOnInit(): void {
    this.getColors();
  }

  updateColorTag({ colorKey }): void {
    this.tagsService.updateTagColor(this.tag.tagKey, colorKey).subscribe({
      next: () => { this.updateTag.emit(); }
    });
  }

  private getColors(): void {
    this.colorService.getColors().subscribe({
      next: colors => {
        this.colors = colors;
        this.selected = colors.find(c => c.colorKey === this.tag?.colorKey);
      }
    });
  }

}
